import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'vex-check-email-2',
  templateUrl: './check-email-2.component.html',
  styleUrls: ['./check-email-2.component.scss']
})
export class CheckEmail2Component {
    constructor(
      private router : Router,) { }
  btnClick() {
    this.router.navigate(['/login']);
  }
}
